import React from 'react';
import {useTranslation} from "react-i18next";
import Dialog from "../../../../../components/ui/Dialog/Dialog";
import AssignOffer from "./AssignOffer";

type AssignOfferDialogProps = {
    id: string | Array<string>;
    show: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const AssignOfferDialog: React.FC<AssignOfferDialogProps> = ({
                                                                 id,
                                                                 show,
                                                                 setShow
                                                             }) => {
    const {t} = useTranslation();

    return (
        <Dialog id={'assign-offer-dialog'}
                show={show}
                setShow={setShow}
                width={'650px'}
                title={Array.isArray(id) && id.length > 1
                    ? t("shared.btn.assign-offers")
                    : t("shared.btn.assign-offer")}>
            <AssignOffer id={id} close={() => setShow(prev => !prev)}/>
        </Dialog>
    );
};

export default AssignOfferDialog;